import './App.css';
import React from 'react';
import {BrowserRouter as Router, Route } from 'react-router-dom';
import ProtectedRoute from './components/route/ProtectedRoute';
import StaffProtectedRoute from './components/route/StaffProtectedRoute';
import HRProtectedRoute from './components/route/HRProtectedRoute';
import RoleRoute from './components/route/RoleRoute';
import RoutesWithFallback from './components/route/RoutesWithFallback';
import { installFriendlyErrors } from './utils/apiError';
import AppErrorBoundary from './components/common/AppErrorBoundary';
import { RouteTitle, SiteFooter } from './components/common/Branding';
// Admin Dashboard Components
import AdminDashboard from './components/AdminDashboard/Dashboard';
import Admins from './Screens/Admin/Admins';
import Organizations from './Screens/Admin/Organizations';
import Personnel from './Screens/Admin/Personnel';
import PersonnelProfile from './Screens/Admin/PersonnelProfile';
import Profile from './Screens/Admin/Profile';
import LandingPage from './Screens/LandingPage';
import Login from './Screens/Login';
import PatientsList from './Screens/Admin/PatientsList'; 
import DoctorsList from './Screens/Admin/DoctorsList'; 
import DoctorProfile from './Screens/Admin/DoctorProfile';
import AddNewDoctor from './Screens/Admin/AddNewDoctor';
import PatientProfile from './Screens/Admin/PatientProfile';
import EditDoctor from './Screens/Admin/EditDoctor';
import AssignDoctorToPatient from './Screens/Admin/AssignDoctorToPatient';
import RPMDevices from './Screens/Admin/RPMDevices';
import EnrollmentCoordinators from './Screens/Admin/EnrollmentCoordinators';
import EnrollmentPatients from './Screens/Enrollment/EnrollmentPatients';
import EnrollmentDevices from './Screens/Enrollment/EnrollmentDevices';
import DeviceAssign from './Screens/Devices/DeviceAssign';
import DeviceRequests from './Screens/DeviceRequests/DeviceRequests';
import DeviceRequestNew from './Screens/DeviceRequests/DeviceRequestNew';
import DeviceRequestDetail from './Screens/DeviceRequests/DeviceRequestDetail';
import DailyEnrollmentRequest from './Screens/DeviceRequests/DailyEnrollmentRequest';
import DeviceRequestBatchPrint from './Screens/DeviceRequests/BatchPrint';
import EcPendingRequests from './Screens/DeviceRequests/EcPendingRequests';
import EcFulfil from './Screens/DeviceRequests/EcFulfil';
import DevicesDetails from './Screens/Admin/DevicesDetails';
import AddRPMDevice from './Screens/Admin/AddRPMDevice';
import UpdateRPMDevice from './Screens/Admin/UpdateRPMDevice';
import PrintReceipt from './Screens/Admin/PrintReceipt';
import AddPatient from './Screens/Admin/AddPatient';
import HRList from './Screens/Admin/HRList';
import HRAdd from './Screens/Admin/HRAdd';
import UpdateHR from './Screens/Admin/UpdateHR';
import HRProfile from './Screens/Admin/HRProfile';
import AssignDrToHr from './Screens/Admin/AssignDrToHr';
import AssignPatientToHr from './Screens/Admin/AssignPatientToHR';
import AdminTimeReport from './Screens/Admin/AdminTimeReport';
import EditPatient from './Screens/Admin/EditPatient';
import InitialMonthReport from './Screens/Admin/InitialMonthReport';
import CompleteInventoryList from './Screens/Admin/CompleteInventoryList';
import AdminResetPassword from './Screens/Admin/AdminResetPassword';
import TelemetaryReport from './Screens/Admin/TelemetaryReport';
import MonthlyReport from './Screens/Admin/MonthlyReport';
import AccountingMonthly from './Screens/Accounting/AccountingMonthly';
import BillingCodes from './Screens/Billing/BillingCodes';
import PracticeSettings from './Screens/Accounting/PracticeSettings';
import InsuranceMissing from './Screens/Insurance/InsuranceMissing';
import TimeSummaryReport from './Screens/Admin/TimeSummaryReport';
import ManageLogs from './Screens/Admin/ManageLogs';
import EditTelemetaryData from './Screens/Admin/EditTelemetaryData';
import FinancialReportHistory from './Screens/Admin/FinancialReportHistory';
import InactivePatients from './Screens/Admin/InactivePatients';
import CCMPatients from './Screens/Admin/CCMPatients';
import TimeReportCCM from './Screens/Admin/TimeReportCCM';
import FinancialReportHistoryCCM from './Screens/Admin/FinancialReportHistoryCCM';
import DevicesHistory from './Screens/Admin/DevicesHistory';
import CCMPatientProfileAdmin from './Screens/Admin/CCMPatientProfileAdmin';
import WeightScaleReport from './Screens/Admin/WeightScaleReport';
import TelemetryReportnurse from './Screens/HR/TelemetryReportNurse';
import BillingReport from './Screens/Admin/BillingReport';
import { NurseBonusReport, DuplicateReview, EnrollmentWarnings, PayerAdmin } from './Screens/Billing/BillingOps';
import CCMBillingReport from './Screens/Admin/CCMBillingReport';
import NursesPerformanceWithDrs from './Screens/Admin/NursesPerformanceWithDrs';
import NurseActivity from './Screens/Admin/NurseActivity';
// Staff Screens
import StaffDashboard from './Screens/Staff/StaffDashboard';
import StaffProfile from './Screens/Staff/StaffProfile';
import StaffPatient from './Screens/Staff/StaffPatients';
import StaffPatientProfile from './Screens/Staff/StaffPatientProfile';
import DoctorAddPatient from './Screens/Staff/DoctorAddPatient';
import DocCareplanList from './Screens/Staff/DocCareplanList';
import DoctorTimeSummaryReport from './Screens/Staff/DoctorTimeSummaryReport';
import FinancialReportCCM from './Screens/Admin/FinancialReportCCM';
import StaffCCMPatients from './Screens/Staff/StaffCCMPatients';
import DoctorPatientProfileCCM from './Screens/Staff/DoctorPatientProfileCCM';
// HR Screens
import HRDashboard from './Screens/HR/HRDashboard'; 
import HRPatientsList from './Screens/HR/HRPatientsList';
import HRPatientProfile from './Screens/HR/HRPatientProfile';
import HR from './Screens/HR/HR';
import TimeReport from './Screens/HR/TimeReport';
import HRAddPatient from './Screens/HR/HRAddPatient';
import CareplanDetails from './Screens/HR/CareplanDetails';
import CareplanList from './Screens/HR/CareplanList';
import NurseCCMPatients from './Screens/HR/NurseCCMPatients';
import CCMPatientProfile from './Screens/HR/CCMPatientProfile';
import MinutesHistory from './Screens/HR/MinutesHistory';
import Chat from './Screens/HR/Chat';
import HRAssignedPatients from './Screens/HR/HRAssignedPatients';
// General links
import ForgotPassword from './Screens/ForgotPassword';
import ResetPassword from './Screens/ResetPassword';

installFriendlyErrors();

function App() {
  return (
    <Router>
      <RouteTitle />
      <AppErrorBoundary>
      <RoutesWithFallback>
        <Route exact path='/' component={LandingPage} />  
        <Route exact path='/login' component={Login} />
        <Route exact path='/auth/forgot' component={ForgotPassword} />
        <Route exact path="/auth/resetPassword/:token" component={ResetPassword} />
        
        <ProtectedRoute exact path='/patients' isAdmin={true} component={PatientsList} />
        <ProtectedRoute exact path='/doctors' isAdmin={true} component={DoctorsList} />
        <ProtectedRoute exact path='/adminDashboard' isAdmin={true} component={AdminDashboard} />
        <ProtectedRoute exact path='/admins' isAdmin={true} superOnly={true} component={Admins} />
        <ProtectedRoute exact path='/organizations' isAdmin={true} superOnly={true} component={Organizations} />
        <ProtectedRoute exact path='/personnel' isAdmin={true} component={Personnel} />
        <ProtectedRoute exact path='/personnel/:kind/:id' isAdmin={true} component={PersonnelProfile} />
        <ProtectedRoute exact path='/doctorProfile' isAdmin={true} component={DoctorProfile} />
        <ProtectedRoute exact path='/me' isAdmin={true} component={Profile} />
        <ProtectedRoute exact path='/adddoctor' isAdmin={true} component={AddNewDoctor} />
        <ProtectedRoute exact path='/patientprofile' isAdmin={true} component={PatientProfile} />
        <ProtectedRoute exact path='/patientprofile/ccm' isAdmin={true} component={CCMPatientProfileAdmin} />
        <ProtectedRoute exact path="/Doctor/Edit" isAdmin={true} component={EditDoctor} />
        <ProtectedRoute exact path='/assigndoctor' isAdmin={true} component={AssignDoctorToPatient} />
        <ProtectedRoute exact path='/devices' isAdmin={true} component={RPMDevices} />
        <ProtectedRoute exact path='/enrollment-coordinators' isAdmin={true} component={EnrollmentCoordinators} />
        <RoleRoute exact path='/enrollment/patients' roles={['enrollment', 'admin', 'adminStaff', 'HrLead']} component={EnrollmentPatients} />
        <RoleRoute exact path='/enrollment/devices' roles={['enrollment']} component={EnrollmentDevices} />
        <RoleRoute exact path='/devices/assign' roles={['enrollment', 'admin', 'adminStaff', 'HrLead']} component={DeviceAssign} />
        <RoleRoute exact path='/device-requests' roles={['admin', 'adminStaff', 'HrMedical', 'HrLead']} component={DeviceRequests} />
        <RoleRoute exact path='/device-requests/new' roles={['admin', 'adminStaff', 'HrMedical', 'HrLead']} component={DeviceRequestNew} />
        <RoleRoute exact path='/device-requests/daily' roles={['admin', 'adminStaff']} component={DailyEnrollmentRequest} />
        <RoleRoute exact path='/device-requests/batches/:id([0-9a-fA-F]{24})' roles={['admin', 'adminStaff', 'enrollment']} component={DeviceRequestBatchPrint} />
        <RoleRoute exact path='/device-requests/:id([0-9a-fA-F]{24})' roles={['admin', 'adminStaff', 'HrMedical', 'HrLead']} component={DeviceRequestDetail} />
        <RoleRoute exact path='/enrollment/device-requests' roles={['enrollment', 'admin']} component={EcPendingRequests} />
        <RoleRoute exact path='/enrollment/device-requests/:id([0-9a-fA-F]{24})' roles={['enrollment', 'admin']} component={EcFulfil} />
        <ProtectedRoute exact path='/devicedetails' isAdmin={true} component={DevicesDetails} />
        <ProtectedRoute exact path='/device' isAdmin={true} component={AddRPMDevice} />
        <ProtectedRoute exact path='/printReceipt' isAdmin={true} component={PrintReceipt} />
        <ProtectedRoute exact path='/updatedevice' isAdmin={true} component={UpdateRPMDevice} />
        <ProtectedRoute exact path='/addpatient' isAdmin={true} component={AddPatient} />
        <ProtectedRoute exact path='/hrlist' isAdmin={true} component={HRList} /> 
        <ProtectedRoute exact path='/addhr' isAdmin={true} component={HRAdd} />
        <ProtectedRoute exact path='/updateHR' isAdmin={true} component={UpdateHR} />
        <ProtectedRoute exact path='/hrProfile' isAdmin={true} component={HRProfile} />
        <ProtectedRoute exact path='/assignDrToHr' isAdmin={true} component={AssignDrToHr} />
        <ProtectedRoute exact path='/assignPatientToHr' isAdmin={true} component={AssignPatientToHr} />
        <ProtectedRoute exact path="/Admin/Report/RPM" isAdmin={true} component={AdminTimeReport} />
        <ProtectedRoute exact path='/Patients/Edit' isAdmin={true} component={EditPatient} />
        <ProtectedRoute exact path="/Admin/Report/InitialMonth" isAdmin={true} component={InitialMonthReport} />
        <ProtectedRoute exact path='/Admin/Inventory/Download' isAdmin={true} component={CompleteInventoryList} />
        <ProtectedRoute exact path="/Credentials" isAdmin={true} superOnly={true} component={AdminResetPassword} />
        <ProtectedRoute exact path='/report/telemetary' isAdmin={true} component={TelemetaryReport} />
        <RoleRoute exact path='/accounting/monthly' roles={['admin', 'adminStaff', 'billing', 'accounting']} component={AccountingMonthly} />
        <RoleRoute exact path='/billing/codes' roles={['admin', 'adminStaff', 'billing']} component={BillingCodes} />
        <RoleRoute exact path='/accounting/practice-settings' roles={['admin', 'accounting']} component={PracticeSettings} />
        <RoleRoute exact path='/insurance/missing' roles={['admin', 'adminStaff', 'billing', 'accounting']} component={InsuranceMissing} />
        <RoleRoute exact path='/report/monthly' roles={['admin', 'adminStaff', 'billing', 'accounting']} component={MonthlyReport} />
        <ProtectedRoute exact path='/report/financialReport' isAdmin={true} component={TimeSummaryReport} />
        <ProtectedRoute exact path='/logs' isAdmin={true} component={ManageLogs} />
        <ProtectedRoute exact path='/edit/telemetarydata' isAdmin={true} component={EditTelemetaryData} />
        <ProtectedRoute exact path='/financialReport/history' isAdmin={true} component={FinancialReportHistory} />
        <ProtectedRoute exact path='/financialReport/CCM' isAdmin={true} component={FinancialReportCCM} />
        <ProtectedRoute exact path='/Patients/Inactive' isAdmin={true} component={InactivePatients} /> 
        <ProtectedRoute exact path='/CCM/Patients' isAdmin={true} component={CCMPatients} /> 
        <ProtectedRoute exact path="/Admin/Report/CCM" isAdmin={true} component={TimeReportCCM} /> 
        <ProtectedRoute exact path="/financialReport/history/CCM" isAdmin={true} component={FinancialReportHistoryCCM} /> 
        <ProtectedRoute exact path="/Devices/History" isAdmin={true} component={DevicesHistory} /> 
        <ProtectedRoute exact path="/report/weight_scale" isAdmin={true} component={WeightScaleReport} /> 
        <RoleRoute exact path='/billing/nurse-bonus' roles={['admin', 'adminStaff', 'accounting', 'HrMedical', 'HrLead']} component={NurseBonusReport} />
        <RoleRoute exact path='/billing/duplicates' roles={['admin', 'adminStaff']} component={DuplicateReview} />
        <RoleRoute exact path='/billing/enrollment-warnings' roles={['admin', 'adminStaff']} component={EnrollmentWarnings} />
        <RoleRoute exact path='/billing/payers' roles={['admin', 'adminStaff', 'billing', 'accounting']} component={PayerAdmin} />
        <ProtectedRoute exact path="/report/billing" isAdmin={true} component={BillingReport} />  
        <ProtectedRoute exact path="/report/billing/ccm" isAdmin={true} component={CCMBillingReport} />  
        <RoleRoute exact path='/nurse-activity/:hrId' roles={['admin', 'adminStaff', 'accounting', 'HrMedical', 'HrLead']} component={NurseActivity} />
        <ProtectedRoute exact path="/performance" isAdmin={true} component={NursesPerformanceWithDrs} />  
      
        {/* Staff Routes */}
        <StaffProtectedRoute exact path="/doctor/dashboard" isStaff={true} component={StaffDashboard} />
        <StaffProtectedRoute exact path="/staffProfile" isStaff={true} component={StaffProfile} />
        <StaffProtectedRoute exact path="/doctor/patients" isStaff={true} component={StaffPatient} />
        <StaffProtectedRoute exact path="/doctor/patient/profile" isStaff={true} component={StaffPatientProfile} />
        <StaffProtectedRoute exact path="/doctor/Addpatient" isStaff={true} component={DoctorAddPatient} />
        <StaffProtectedRoute exact path="/doctor/careplan" isStaff={true} component={DocCareplanList} />
        <StaffProtectedRoute exact path="/doctor/report/financialReport" isStaff={true} component={DoctorTimeSummaryReport} />
        <StaffProtectedRoute exact path="/CCM/doctor/patients" isStaff={true} component={StaffCCMPatients} />
        <StaffProtectedRoute exact path="/doctor/patientprofile/ccm" isStaff={true} component={DoctorPatientProfileCCM} />
        {/* HR Routes */}
        <HRProtectedRoute exact path="/Nurse/Dashboard" isHR={true} component={HRDashboard} />
        <HRProtectedRoute exact path="/Nurse/Patients" isHR={true} component={HRPatientsList} />
        <HRProtectedRoute exact path="/Nurse/Patient/Profile" isHR={true} component={HRPatientProfile} />
        <HRProtectedRoute exact path="/hr" isHR={true} component={HR} />
        <HRProtectedRoute exact path="/Nurse/Report/TimeReport" isHR={true} component={TimeReport} />
        <HRProtectedRoute exact path="/Nurse/Add_New_Patient" isHR={true} component={HRAddPatient} />
        <HRProtectedRoute exact path="/Nurse/Careplan" isHR={true} component={CareplanDetails} />
        <HRProtectedRoute exact path="/Nurse/careplans" isHR={true} component={CareplanList} />
        <HRProtectedRoute exact path="/CCM/Nurse/Patients" isHR={true} component={NurseCCMPatients} />
        <HRProtectedRoute exact path="/Nurse/Patient/CCM/Profile" isHR={true} component={CCMPatientProfile} />
        <HRProtectedRoute exact path="/Nurse/Minutes/History" isHR={true} component={MinutesHistory} />
        <HRProtectedRoute exact path="/Nurse/Chat" isHR={true} component={Chat} />
        <HRProtectedRoute exact path="/Nurse/Assigned/Patients" isHR={true} component={HRAssignedPatients} />    
        <HRProtectedRoute exact path="/Nurse/TelemetryDataReport" isHR={true} component={TelemetryReportnurse} />
      </RoutesWithFallback>
      <SiteFooter />
      </AppErrorBoundary>
    </Router>
  )      
};

export default App;
